module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-hp__wrapper"
  }, [_c('div', {
    ref: "parent",
    staticClass: "cb-header cb-transition__slide",
    attrs: {
      "id": "cb-header"
    }
  }, [(_vm.allowed) ? _c('header-1', {
    directives: [{
      name: "cb-slide",
      rawName: "v-cb-slide",
      value: ({
        isnew: true,
        ref: _vm.$refs.parent
      }),
      expression: "{ isnew : true , ref: $refs.parent }"
    }],
    key: _vm.$route.path,
    tag: "component"
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "cb-body",
    attrs: {
      "id": "cb-body",
      "role": "main"
    }
  }, [(_vm.inited && _vm.allowed) ? _c('div', {
    directives: [{
      name: "cb-animate",
      rawName: "v-cb-animate",
      value: (true),
      expression: "true"
    }],
    staticClass: "cb-body__wrap"
  }, [_c('div', {
    staticClass: "cb-auth"
  }, [_c('div', {
    ref: "authParent",
    staticClass: "cb-auth__group--spacer cb-auth__slide"
  }, [_c('cb-toggle', {
    attrs: {
      "parent": _vm.$refs.authParent,
      "recalculateMargin": true
    }
  }, [(_vm.step == 'step1') ? _c('div', {
    key: "email",
    staticClass: "cb-text"
  }, [_c('div', {
    staticClass: "cb-auth__label",
    style: (_vm.themeColor)
  }, [_vm._v(_vm._s(_vm.headerTxt))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "x2",
    staticClass: "cb-text__control",
    class: {
      'cb-text__control--error': _vm.errorMessage && _vm.errorMessage.length > 0
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.placeholder,
      "autofocus": "",
      "aria-label": _vm.headerTxt
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.next()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cb-text__error cb-text__error--center"
  }, [_vm._v("\n                " + _vm._s(_vm.errorMessage) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.step == 'step2') ? _c('div', {
    key: "password"
  }, [((_vm.step == 'step2') && _vm.email) ? _c('div', {
    staticClass: "cb-auth__email-desc"
  }, [_c('div', {
    staticClass: "icon icon-account-circle",
    style: (_vm.themeColor)
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.email))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cb-auth__label",
    style: (_vm.themeColor)
  }, [_vm._v(_vm._s(_vm.headerTxt))]), _vm._v(" "), (!_vm.showPassword) ? _c('div', {
    key: _vm.showPassword,
    staticClass: "cb-transition__fade--short"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otp),
      expression: "otp"
    }],
    ref: "x1",
    staticClass: "cb-text__control cb-text__control--lg cb-text__control--center",
    class: {
      'cb-field__control--error': _vm.errorMessage && _vm.errorMessage.length > 0
    },
    style: (_vm.themeColor),
    attrs: {
      "type": "number",
      "pattern": "[0-9]{6}",
      "maxlength": "6",
      "autocomplete": "off",
      "name": "otp",
      "id": "otp",
      "aria-label": _vm.headerTxt
    },
    domProps: {
      "value": (_vm.otp)
    },
    on: {
      "keydown": function($event) {
        _vm.keydown($event)
      },
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.next()
      }, function($event) {
        _vm.errorMessage = ''
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otp = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _c('div', {
    key: _vm.showPassword,
    staticClass: "cb-transition__fade--short"
  }, [_c('cb-password', {
    ref: "pwd",
    attrs: {
      "error": _vm.errorMessage,
      "value": _vm.password
    },
    on: {
      "keyupEnter": function($event) {
        _vm.next()
      },
      "keyupCustom": function($event) {
        _vm.password = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cb-text__error cb-text__error--center"
  }, [_vm._v("\n                " + _vm._s(_vm.errorMessage) + "\n              ")]), _vm._v(" "), (_vm.is_otp_pwd && _vm.showPassword && _vm.has_password) ? _c('div', {
    staticClass: "cb-auth__link"
  }, [_c('span', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('color'),
      expression: "'color'"
    }],
    attrs: {
      "role": "link"
    },
    on: {
      "click": function($event) {
        _vm.forgotPwd()
      }
    }
  }, [_vm._v(_vm._s(_vm.nlt('forgot_password.link.txt')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cb-auth__link"
  }, [_c('span', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('color'),
      expression: "'color'"
    }],
    attrs: {
      "role": "link"
    },
    on: {
      "click": function($event) {
        _vm.resendOtp()
      }
    }
  }, [_vm._v(_vm._s(_vm.otpText) + " "), (_vm.showPassword) ? [_vm._v("→")] : _vm._e()], 2)]), _vm._v(" "), (!_vm.showPassword && _vm.has_password) ? _c('div', {
    staticClass: "cb-auth__link"
  }, [_c('span', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('color'),
      expression: "'color'"
    }],
    key: _vm.showPassword,
    attrs: {
      "role": "link"
    },
    on: {
      "click": function($event) {
        _vm.enterPassword($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.nlt('password.use')) + "→")])]) : _vm._e()]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cb-body__footer"
  }, [_c('button-field', {
    attrs: {
      "custom-class": 'primary',
      "showLoader": _vm.showLoader,
      "attr": 'portal_auth_action'
    },
    on: {
      "next": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.btnTxt) + " "), _c('i', {
    staticClass: "icon-long-arrow-right"
  })])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.allowed) ? _c('div', {
    staticClass: "cb-body__wrap"
  }, [_vm._v("\n      " + _vm._s(_vm.st('page_not_found')) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e06aed7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/portal/PortalLogin.vue
// module id = 653
// module chunks = 84